import { render, staticRenderFns } from "./MonitorEditDialog.vue?vue&type=template&id=32b970de&scoped=true"
import script from "./MonitorEditDialog.vue?vue&type=script&lang=js"
export * from "./MonitorEditDialog.vue?vue&type=script&lang=js"
import style0 from "./MonitorEditDialog.vue?vue&type=style&index=0&id=32b970de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_2aqslel7prtkk4onzp5d3vudie/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b970de",
  null
  
)

export default component.exports